import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PresentDeviceUserStore } from '@/app/platform/platform-data/store/present-device-user.store';
import { PresentDeviceUserQueries } from '@/app/platform/platform-data/queries/types';
import { PresentUserData } from '@/app/platform/platform-data/models/present-user-data';
import { PresentDeviceUserFilters } from '@/app/platform/platform-data/services/types';

@Injectable({ providedIn: 'root' })
export class PresentDeviceUserStoreQueries implements PresentDeviceUserQueries {
  constructor(protected store: PresentDeviceUserStore) {}

  readonly all$: Observable<PresentUserData[]> = this.store.selectAll();
  readonly filters$: Observable<PresentDeviceUserFilters> = this.store.select(s => s.filters);

  getAll(): PresentUserData[] {
    return this.store.getAll();
  }
}
